import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { instance } from "../configApi";

const initialState = {
  msg: "",
  isNotify: false,
  isLoading: false,
  callBackRequest: false,
  typeNotify: "success",
  valuDeleteConfig: "",
  data: [],
  total: 0,
  config: {
    search: "",
    categories: 0,
    status: 1,
    option: {
      limit: 10,
      offset: 1,
      order: "desc",
    },
  },
  idNews: "",
  isOpenModalGetLogNews: false,
  isOpenModalAddNews: false,
  isOpenModalDetail: false,
  detailByID: [],
  dataLog: [],
  dataBasePageOne: [],
  dataGhim: [],
  dataSaveConfig: [],
  refetchConfig: false,
};
const NewsSlice = createSlice({
  name: "news",
  initialState,
  reducers: {
    resetState: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.isLoading = false;
      state.callBackRequest = false;
      state.typeNotify = "success";
      state.data = [];
      state.total = 0;
      state.config.search = "";
      state.config.status = 1;
      state.config.option.limit = 10;
      state.config.option.offset = 1;
      state.config.option.order = "desc";
      state.idNews = "";
      state.isOpenModalGetLogNews = false;
      state.isOpenModalAddNews = false;
      state.isOpenModalDetail = false;
      state.detailByID = [];
      state.dataLog = [];
    },
    setSearchText: (state, action) => {
      state.config.search = action.payload;
      state.config.option.offset = 1;
    },
    setPageNews: (state, action) => {
      state.config.option.offset = action.payload;
    },
    setOpenDetailNews: (state, action) => {
      state.isOpenModalDetail = action.payload.isOpen;
      state.idNews = action.payload.id;
    },
    setOpenModalGetLogNews: (state, action) => {
      state.isOpenModalGetLogNews = action.payload;
    },
    setOpenModalAddNews: (state, action) => {
      state.isOpenModalAddNews = action.payload;
    },
    setDataGhim: (state, action) => {
      state.dataGhim = action.payload;
    },
    resetStateNews: (state) => {
      state.msg = "";
      state.isNotify = false;
      state.isLoading = false;
      state.callBackRequest = false;
      state.data = [];
      state.total = 0;
      state.config.search = "";
      state.config.status = 1;
      state.config.option.offset = 1;
    },
    setConfigCategoris: (state, action) => {
      state.config.categories = action.payload;
    },
    resetStatusNews: (state) => {
      state.isLoading = false;
      state.isNotify = false;
      state.msg = "";
      state.typeNotify = "";
    },
    setDataBasePageOne: (state, action) => {
      state.dataBasePageOne.push({
        ...action.payload,
        index: state.dataBasePageOne.length + 1,
      });
    },
    setDataSaveConfig: (state, action) => {
      state.dataSaveConfig = action.payload;
    },
    setValueDeleteConfig: (state, action) => {
      state.valuDeleteConfig = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //add news
      .addCase(createPostNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPostNews.fulfilled, (state, action) => {
        if (action.payload === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Thêm bài viết thành công";
          state.callBackRequest = true;
          state.isOpenModalAddNews = false;
        }
      })
      .addCase(createPostNews.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      //edit news
      .addCase(editPostNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editPostNews.fulfilled, (state, action) => {
        if (action.payload === 200) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Sửa bài viết thành công";
          state.callBackRequest = true;
        }
      })
      .addCase(editPostNews.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })

      // get data news
      .addCase(getPostNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPostNews.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.data = action.payload.data;
        state.total = action.payload.total;
        state.callBackRequest = false;
      })
      .addCase(getPostNews.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })

      //delete data news
      .addCase(deletePostNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deletePostNews.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.callBackRequest = true;
        state.isNotify = true;
        state.msg = "Xóa bài viết thành công";
      })
      .addCase(deletePostNews.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // get data detail news
      .addCase(getDetailPostNews.pending, (state) => {
        state.isLoading = true;
        state.detailByID = [];
      })
      .addCase(getDetailPostNews.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.detailByID = action.payload;
      })
      .addCase(getDetailPostNews.rejected, (state) => {
        state.isNotify = false;
        state.isLoading = false;
      })
      // get log news
      .addCase(getLogNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLogNews.fulfilled, (state, action) => {
        state.isNotify = false;
        state.isLoading = false;
        state.dataLog = action.payload;
        state.isOpenModalGetLogNews = true;
      })
      .addCase(getLogNews.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // add firs page
      .addCase(addFirstPage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addFirstPage.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Thêm vào trang 1 thành công";
          state.refetchConfig = true;
        }
      })
      .addCase(addFirstPage.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // save config firs page
      .addCase(saveConfigNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveConfigNews.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Lưu thiết lập thành công";
        }
      })
      .addCase(saveConfigNews.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // save change prominence
      .addCase(saveChangePromience.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(saveChangePromience.fulfilled, (state, action) => {
        if (action.payload === 1) {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Lưu thiết lập thành công";
          state.typeNotify = "success";
        } else {
          state.isNotify = true;
          state.isLoading = false;
          state.msg = "Lỗi server";
          state.typeNotify = "error";
        }
      })
      .addCase(saveChangePromience.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // delete item config firs page
      .addCase(deleteItemConfigNews.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteItemConfigNews.fulfilled, (state, action) => {
        if (action.payload.status === 1) {
          state.isNotify = true;
          state.isLoading = false;
          if (
            state.dataGhim.find((item) => item.id === state.valuDeleteConfig.id)
          ) {
            state.dataGhim = state.dataGhim.filter(
              (item) => item.id !== state.valuDeleteConfig.id
            );
          } else {
            state.dataBasePageOne = state.dataBasePageOne.filter(
              (item) => item.id !== state.valuDeleteConfig.id
            );
          }
          state.msg = "Xóa thành công";
        }
      })
      .addCase(deleteItemConfigNews.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      })
      // get data first page
      .addCase(getDataFirstPage.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDataFirstPage.fulfilled, (state, action) => {
        const arrGhim = [];
        const arrData = [];
        action.payload.map((item) => {
          if (item.pin) {
            return arrGhim.push(item);
          } else return arrData.push(item);
        });
        state.dataGhim = arrGhim;
        state.dataBasePageOne = arrData;
        state.isLoading = false;
        state.refetchConfig = false;
      })
      .addCase(getDataFirstPage.rejected, (state) => {
        state.isNotify = true;
        state.isLoading = false;
      });
  },
});
export default NewsSlice;

export const {
  resetStatusNews,
  setPageNews,
  setOpenModalGetLogNews,
  resetStateNews,
  setSearchText,
  setOpenDetailNews,
  setOpenModalAddNews,
  resetState,
  setDataBasePageOne,
  setDataGhim,
  setDataSaveConfig,
  setValueDeleteConfig,
  setConfigCategoris,
} = NewsSlice.actions;

export const createPostNews = createAsyncThunk(
  "news/createPostNews",
  async (data) => {
    try {
      const res = await instance.post("/news/createPost", data, {
        headers: {
          "Content-type": "multipart/form-date",
        },
      });
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
export const editPostNews = createAsyncThunk(
  "news/editPostNews",
  async (data) => {
    try {
      const res = await instance.put("/news/editPost", data, {
        headers: {
          "Content-type": "multipart/form-date",
        },
      });
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);
export const deletePostNews = createAsyncThunk(
  "news/deletePostNews",
  async (id) => {
    try {
      const res = await instance.delete(`/news/deletePost/${id}`);
      return res.status;
    } catch (error) {
      console.log(error);
      return error.reponse.data;
    }
  }
);

export const getPostNews = createAsyncThunk(
  "news/getPostNews",
  async (options) => {
    try {
      const config = options
        ? options
        : {
            search: "",
            // status: 1,
            option: {
              limit: 10,
              offset: 1,
              order: "desc",
            },
          };
      const res = await instance.post("/news/adminPageable", config);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getDetailPostNews = createAsyncThunk(
  "news/getDetailPostNews",
  async (id) => {
    try {
      const res = await instance.get(`/news/getPost/${id}`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
export const getLogNews = createAsyncThunk("news/getLogNews", async (id) => {
  try {
    const res = await instance.get(`newsLog/getLog/${id}`);
    const result = res.data;
    return result.data;
  } catch (error) {
    console.log(error);
  }
});
// add first page
export const addFirstPage = createAsyncThunk(
  "news/addFirstPage",
  async (body) => {
    console.log(body);
    try {
      const res = await instance.post(`/firstPageNews/addFirstPageNews`, body);
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
// get data first page
export const getDataFirstPage = createAsyncThunk(
  "news/getDataFirstPage",
  async () => {
    try {
      const res = await instance.get(`/firstPageNews/getAll?search=`);
      const result = res.data;
      return result.data;
    } catch (error) {
      console.log(error);
    }
  }
);
//save config
export const saveConfigNews = createAsyncThunk(
  "news/saveConfigNews",
  async (body) => {
    try {
      const res = await instance.post(`/firstPageNews/saveAll`, body);
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
export const deleteItemConfigNews = createAsyncThunk(
  "news/deleteItemConfigNews",
  async (id) => {
    try {
      const res = await instance.delete(`/firstPageNews/deleteNews/${id}`);
      const result = res.data;
      return result;
    } catch (error) {
      console.log(error);
    }
  }
);
// save change prominence
export const saveChangePromience = createAsyncThunk(
  "news/saveChangePromience",
  async (data) => {
    try {
      const res = await instance.put(`/news/changeProminence`, data);
      const result = res.data;
      return result.status;
    } catch (error) {
      console.log(error);
    }
  }
);
